import type { ReactNode } from "react";

interface WorkspacePanelHeadingProps {
	title: ReactNode;
	/** Extra content under the title, e.g. the Resources actions. */
	children?: ReactNode;
}

/** Column title shared by the Resources, Chat and Studio panels. */
export function WorkspacePanelHeading({
	title,
	children,
}: WorkspacePanelHeadingProps) {
	return (
		<div className="px-4 pt-7 pb-2">
			<h2 className="text-xl font-semibold text-text-primary border-b border-border-subtle pb-2">
				{title}
			</h2>
			{children}
		</div>
	);
}
